import React, { useState } from "react";
import { AnimatePresence, easeOut, motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { ChevronIcon } from "@components/icons/common";

interface IExpandingContainerProps {
  children?: React.ReactNode;
  isEnabled?: boolean;
  buttonLabel: string;
  defaultOpen?: boolean;
  className?: string;
}

export const ExpandingContainer: React.FC<IExpandingContainerProps> = (
  props,
) => {
  const { children, isEnabled, buttonLabel, defaultOpen, className } = props;

  const [open, setOpen] = useState(defaultOpen ? true : false);

  if (isEnabled === false) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <div className={twMerge("w-full overflow-hidden", className)}>
      <button
        className={twMerge("flex items-center gap-2", open && "pb-5")}
        onClick={() => setOpen(!open)}
      >
        <ChevronIcon
          className={twMerge(
            "size-5 transition duration-200",
            open && "rotate-180",
          )}
        />
        <span className="text-left text-sm font-semibold">{buttonLabel}</span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -24, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -24, height: 0 }}
            transition={{ duration: 0.2, ease: easeOut }}
            className="flex w-full origin-top flex-col gap-3"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
